import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'

import classNames from 'classnames'

import * as CustomEvent from '@/checkout-instore-legacy/utils/CustomEvent'
import { TopbarMessageContainer } from '@/checkout-instore-legacy/topbar'
import Content from './Content'
import { genericImportantEvent } from '@/checkout-instore-legacy/utils/EventHelper'

import { getCurrentRouteByLocation } from '@/checkout-instore-legacy/utils/getCurrentRouteByLocation'

class Topbar extends React.Component {
  checkChangesTimeout = null

  backFallback = () => {
    const TIMEOUT_DELAY = 1000
    const currentRoute = getCurrentRouteByLocation(this.props.match.path)
    const fallbackRoute = currentRoute.backRouteFallback
      ? currentRoute.backRouteFallback(currentRoute)
      : '/cart'

    return setTimeout(() => {
      const { router } = this.props
      router.push(fallbackRoute)

      genericImportantEvent('topbar-back-action', {
        description: 'Forced redirect required',
        redirectFrom: this.props.location.pathname,
        redirectTo: fallbackRoute,
      })
    }, TIMEOUT_DELAY)
  }

  handleGoBackClick = () => {
    const { router, location } = this.props
    const backEvent = CustomEvent.sendEvent('topbar.back', { router, location })

    if (!backEvent.defaultPrevented) {
      router.goBack()
      this.checkChangesTimeout = this.backFallback()
    }
  }

  handleCloseClick = () => {
    const { onClose } = this.props
    onClose && onClose()
  }

  componentDidUpdate(previousProps) {
    if (this.props.location.pathname !== previousProps.location.pathname) {
      clearTimeout(this.checkChangesTimeout)
    }
  }

  render() {
    const { mode } = this.props
    const isModal = mode === 'modal'
    const isSearchMode = mode === 'search'

    return (
      <div>
        <div
          className={`bg-base b--black-20 flex flex-column ${classNames({
            'bn-l': isModal,
            bb: !isSearchMode,
          })}`}
        >
          <div className="pv4">
            <Content {...this.props} onBack={this.handleGoBackClick} />
          </div>
        </div>
        <div className="relative">
          <div className="absolute w-100 w-75-l z-2">
            <TopbarMessageContainer />
          </div>
        </div>
      </div>
    )
  }
}

Topbar.propTypes = {
  setSidebarVisibility: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  onClose: PropTypes.func,
  mode: PropTypes.oneOf(['normal', 'search', 'modal']),
  routes: PropTypes.array,
}

Topbar.defaultProps = {
  mode: 'normal',
}

export default withRouter(Topbar)
